import { castArray, filter, some, get, each, presence, find, toString } from 'lodash'

const optionOrValue = (filterOption) => get(filterOption, 'value', filterOption)

const getDefaultFiltersFromParams = ({ filterParams = {}, defaultFilters = {}, filterOptions = [] }) => {
  const filteredFilterOptions = {}
  each(filterParams, (v, filterKey) => {
    const foundOption = presence(filterOptions[filterKey], {})
    let foundOptions = null

    if (foundOption.isMulti) {
      foundOptions = filter(foundOption.options, filterOption => some(castArray(v), param => param === toString(optionOrValue(filterOption))))
    } else {
      foundOptions = optionOrValue(find(foundOption.options, filterOption => toString(optionOrValue(filterOption)) === toString(v)))
    }

    filteredFilterOptions[filterKey] = presence(foundOptions, defaultFilters[filterKey])
  })

  return { ...defaultFilters, ...filteredFilterOptions }
}

export { getDefaultFiltersFromParams }
